import { useMsal, useAccount } from '@azure/msal-react';
import { loginRequest } from '../../msalConfig';

const useTokenGetter = () => {
	const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]);

	const getToken = async () => {
		let token;
		try {
			const response = await instance.acquireTokenSilent({
				...loginRequest,
				account,
			});
			token = `Bearer ${response.accessToken}`;
		} catch (err) {
      console.error(err);
    }
		return token;
	};

	return getToken;
};

export default useTokenGetter;
